export const WHATSAPP_URL =
  "https://wa.me/6281116613328?text=Halo%20CV%20Trinita%20Bahana%20Persada%2C%20saya%20ingin%20berkonsultasi%20mengenai%20kebutuhan%20marine%20supply%20dan%20layanan%20maritim.";

export const WHATSAPP_QUOTE_URL =
  "https://wa.me/6281116613328?text=Halo%20CV%20Trinita%20Bahana%20Persada%2C%20saya%20ingin%20mengajukan%20Request%20Quotation%20untuk%20layanan%20Marine%20Supply%20%2F%20Maritime%20Support.%20Mohon%20info%20penawaran%20terbaiknya.";

export const waServiceUrl = (service) =>
  `https://wa.me/6281116613328?text=${encodeURIComponent(
    `Halo CV Trinita Bahana Persada, saya ingin menanyakan layanan ${service}. Mohon info produk dan penawaran terbaiknya.`
  )}`;

export const translations = {
  id: {
    nav: {
      about: "Tentang Kami",
      vision: "Visi & Misi",
      services: "Layanan",
      industries: "Industri",
      gallery: "Galeri",
      why: "Keunggulan",
      contact: "Kontak",
      quote: "Request Quotation",
    },
    hero: {
      tagline: "Mitra Terpercaya untuk Marine Supply & Maritime Support Sejak 2014",
      headlineLines: ["Marine Supply,", "Ship Chandler &", "Crew Support Solutions"],
      desc: "CV Trinita Bahana Persada bergerak di bidang Ship Chandler, Marine Supply, Working Gear Supply, Crew Documentation Services, serta Visa & Embassy Services — melayani kebutuhan industri maritim Indonesia sejak 2014 dengan solusi yang cepat, profesional, dan terpercaya.",
      quote: "Request Quotation",
      wa: "Hubungi Kami",
      scroll: "Gulir",
    },
    marquee: ["Ship Chandler", "Working Gear & PPE", "Crew Documentation", "Visa & Embassy", "Since 2014"],
    about: {
      number: "01",
      chapter: "Tentang Kami",
      title: "Satu Perusahaan, Solusi Maritim Terpadu",
      p1: "CV Trinita Bahana Persada adalah perusahaan yang menyediakan solusi terpadu untuk kebutuhan operasional industri maritim. Berawal sebagai Ship Chandler pada tahun 2014, kami terus berkembang dengan menghadirkan layanan Marine Supply, Working Gear, Crew Documentation, dan Visa Services sehingga pelanggan dapat memperoleh berbagai kebutuhan dalam satu perusahaan.",
      p2: "Berbekal pengalaman lebih dari satu dekade, kami berkomitmen memberikan solusi yang cepat, profesional, dan terpercaya bagi perusahaan pelayaran, manning agency, ship management, offshore company, serta berbagai sektor industri maritim. Dengan mengutamakan kualitas produk, ketepatan waktu, dan pelayanan yang responsif, kami hadir sebagai mitra bisnis yang dapat diandalkan dalam mendukung kelancaran operasional pelanggan.",
      stats: [
        { value: "2014", label: "Berdiri Sejak" },
        { value: "10+", label: "Tahun Pengalaman" },
        { value: "4", label: "Layanan Terpadu" },
        { value: "24/7", label: "Dukungan Responsif" },
      ],
    },
    vision: {
      number: "02",
      chapter: "Visi & Misi",
      visiTitle: "Visi",
      visi: "Menjadi perusahaan Maritime Support Services yang terpercaya, profesional, dan berdaya saing tinggi dalam menyediakan solusi terpadu bagi industri maritim di Indonesia maupun pasar internasional.",
      misiTitle: "Misi",
      misi: [
        "Menyediakan produk dan layanan berkualitas tinggi sesuai kebutuhan industri maritim.",
        "Memberikan pelayanan yang cepat, tepat, dan profesional kepada setiap pelanggan.",
        "Membangun hubungan bisnis jangka panjang berdasarkan kepercayaan dan integritas.",
        "Mengembangkan sumber daya manusia yang kompeten serta menjunjung tinggi etika bisnis.",
        "Terus berinovasi untuk memberikan solusi terbaik bagi kebutuhan pelanggan.",
      ],
    },
    services: {
      number: "03",
      chapter: "Layanan Kami",
      title: "Comprehensive Maritime Support Solutions",
      desc: "CV Trinita Bahana Persada menyediakan berbagai layanan pendukung industri maritim yang dirancang untuk membantu perusahaan pelayaran, ship management, manning agency, operator kapal, offshore company, dan perusahaan terkait memenuhi kebutuhan operasional secara lebih efisien.",
      desc2: "Dengan pengalaman sejak 2014, kami menggabungkan kemampuan pengadaan, penyediaan perlengkapan kerja, dukungan administrasi crew, serta layanan visa dan embassy dalam satu jaringan layanan yang terintegrasi.",
      items: [
        {
          title: "Ship Chandler",
          subtitle: "Marine Supply & Vessel Operational Support",
          desc: "Penyediaan berbagai kebutuhan operasional kapal, mulai dari deck stores, engine stores, cabin stores, galley stores, technical supplies, safety equipment, hingga consumables.",
        },
        {
          title: "Working Gear & PPE Supply",
          subtitle: "Quality Workwear & Personal Protective Equipment",
          desc: "Penyediaan coverall, boiler suit, safety shoes, helmet, gloves, reflective vest, uniform, dan berbagai perlengkapan keselamatan kerja.",
        },
        {
          title: "Crew Documentation Services",
          subtitle: "Professional Support for Seafarer Documentation",
          desc: "Dukungan pengurusan dan administrasi dokumen pelaut, termasuk document renewal, certificate, endorsement, passport, medical coordination, dan document monitoring.",
        },
        {
          title: "Visa & Embassy Services",
          subtitle: "Visa Application & Embassy Assistance",
          desc: "Dukungan persiapan dokumen, visa application, embassy appointment, transit visa, dan administrasi perjalanan sesuai persyaratan negara tujuan.",
        },
      ],
      learnMore: "Learn More",
      cta: "Diskusikan Kebutuhan Anda",
    },
    industries: {
      number: "04",
      chapter: "Industri yang Kami Layani",
      title: "Industries We Serve",
      items: [
        "Shipping Companies",
        "Ship Owners",
        "Ship Management",
        "Manning Agencies",
        "Tug & Barge Operators",
        "Offshore Companies",
        "Marine Contractors",
        "Oil & Gas Companies",
        "Industrial Companies",
        "Construction Companies",
      ],
    },
    why: {
      number: "05",
      chapter: "Keunggulan Kami",
      title: "Mengapa Memilih Kami",
      items: [
        "Berpengalaman sejak tahun 2014",
        "Solusi terpadu untuk kebutuhan industri maritim",
        "Produk berkualitas dengan harga kompetitif",
        "Pelayanan cepat, profesional, dan responsif",
        "Berkomitmen terhadap kepuasan pelanggan",
        "Didukung tim yang memahami kebutuhan industri pelayaran",
      ],
    },
    gallery: {
      number: "06",
      chapter: "Galeri",
      title: "Our Work",
      desc: "Dokumentasi kegiatan operasional dan layanan CV Trinita Bahana Persada di lapangan.",
    },
    cta: {
      title: "Butuh Marine Supply atau Layanan Pendukung Maritim?",
      desc: "Tim kami siap membantu kebutuhan perusahaan Anda dengan solusi yang profesional, cepat, dan terpercaya. Hubungi kami sekarang untuk mendapatkan konsultasi dan penawaran terbaik.",
      quote: "Request Quotation",
      wa: "Hubungi Kami",
    },
    footer: {
      desc: "Mitra terpercaya untuk Marine Supply, Working Gear, Crew Documentation, dan Visa Services bagi industri maritim Indonesia sejak 2014.",
      contactTitle: "Kontak",
      linksTitle: "Navigasi",
      rights: "CV Trinita Bahana Persada. Seluruh hak cipta dilindungi.",
    },
  },
  en: {
    nav: {
      about: "About Us",
      vision: "Vision & Mission",
      services: "Services",
      industries: "Industries",
      gallery: "Gallery",
      why: "Why Us",
      contact: "Contact",
      quote: "Request Quotation",
    },
    hero: {
      tagline: "Trusted Partner for Marine Supply & Maritime Support Since 2014",
      headlineLines: ["Marine Supply,", "Ship Chandler &", "Crew Support Solutions"],
      desc: "CV Trinita Bahana Persada operates in Ship Chandler, Marine Supply, Working Gear Supply, Crew Documentation Services, and Visa & Embassy Services — serving the Indonesian maritime industry since 2014 with fast, professional, and reliable solutions.",
      quote: "Request Quotation",
      wa: "Contact Us",
      scroll: "Scroll",
    },
    marquee: ["Ship Chandler", "Working Gear & PPE", "Crew Documentation", "Visa & Embassy", "Since 2014"],
    about: {
      number: "01",
      chapter: "About Us",
      title: "One Company, Integrated Maritime Solutions",
      p1: "CV Trinita Bahana Persada provides integrated solutions for the operational needs of the maritime industry. Starting as a Ship Chandler in 2014, we have grown to offer Marine Supply, Working Gear, Crew Documentation, and Visa Services — so our clients can meet a wide range of needs within a single company.",
      p2: "With more than a decade of experience, we are committed to delivering fast, professional, and trusted solutions for shipping companies, manning agencies, ship management, offshore companies, and the wider maritime sector. By prioritizing product quality, on-time delivery, and responsive service, we stand as a reliable business partner supporting the smooth operations of our clients.",
      stats: [
        { value: "2014", label: "Established" },
        { value: "10+", label: "Years of Experience" },
        { value: "4", label: "Integrated Services" },
        { value: "24/7", label: "Responsive Support" },
      ],
    },
    vision: {
      number: "02",
      chapter: "Vision & Mission",
      visiTitle: "Vision",
      visi: "To become a trusted, professional, and highly competitive Maritime Support Services company providing integrated solutions for the maritime industry in Indonesia and international markets.",
      misiTitle: "Mission",
      misi: [
        "To provide high-quality products and services tailored to the needs of the maritime industry.",
        "To deliver fast, accurate, and professional service to every client.",
        "To build long-term business relationships founded on trust and integrity.",
        "To develop competent human resources while upholding the highest business ethics.",
        "To continuously innovate in delivering the best solutions for our clients' needs.",
      ],
    },
    services: {
      number: "03",
      chapter: "Our Services",
      title: "Comprehensive Maritime Support Solutions",
      desc: "CV Trinita Bahana Persada provides a wide range of maritime support services designed to help shipping companies, ship management, manning agencies, vessel operators, offshore companies, and related businesses meet their operational needs more efficiently.",
      desc2: "With experience since 2014, we combine procurement capabilities, working gear supply, crew administration support, and visa & embassy services into one integrated service network.",
      items: [
        {
          title: "Ship Chandler",
          subtitle: "Marine Supply & Vessel Operational Support",
          desc: "Provision of a wide range of vessel operational needs — from deck stores, engine stores, cabin stores, and galley stores to technical supplies, safety equipment, and consumables.",
        },
        {
          title: "Working Gear & PPE Supply",
          subtitle: "Quality Workwear & Personal Protective Equipment",
          desc: "Supply of coveralls, boiler suits, safety shoes, helmets, gloves, reflective vests, uniforms, and a wide range of occupational safety equipment.",
        },
        {
          title: "Crew Documentation Services",
          subtitle: "Professional Support for Seafarer Documentation",
          desc: "Support for seafarer document processing and administration, including document renewal, certificates, endorsements, passports, medical coordination, and document monitoring.",
        },
        {
          title: "Visa & Embassy Services",
          subtitle: "Visa Application & Embassy Assistance",
          desc: "Support for document preparation, visa applications, embassy appointments, transit visas, and travel administration in accordance with destination country requirements.",
        },
      ],
      learnMore: "Learn More",
      cta: "Discuss Your Requirements",
    },
    industries: {
      number: "04",
      chapter: "Industries We Serve",
      title: "Industries We Serve",
      items: [
        "Shipping Companies",
        "Ship Owners",
        "Ship Management",
        "Manning Agencies",
        "Tug & Barge Operators",
        "Offshore Companies",
        "Marine Contractors",
        "Oil & Gas Companies",
        "Industrial Companies",
        "Construction Companies",
      ],
    },
    why: {
      number: "05",
      chapter: "Our Strengths",
      title: "Why Choose Us",
      items: [
        "Experienced since 2014",
        "Integrated solutions for the maritime industry",
        "Quality products at competitive prices",
        "Fast, professional, and responsive service",
        "Committed to customer satisfaction",
        "Supported by a team that understands the shipping industry",
      ],
    },
    gallery: {
      number: "06",
      chapter: "Gallery",
      title: "Our Work",
      desc: "A look at CV Trinita Bahana Persada's field operations and service activities.",
    },
    cta: {
      title: "Need Marine Supply or Maritime Support Services?",
      desc: "Our team is ready to support your company's needs with professional, fast, and trusted solutions. Contact us now for consultation and the best quotation.",
      quote: "Request Quotation",
      wa: "Contact Us",
    },
    footer: {
      desc: "Trusted partner for Marine Supply, Working Gear, Crew Documentation, and Visa Services for the Indonesian maritime industry since 2014.",
      contactTitle: "Contact",
      linksTitle: "Navigation",
      rights: "CV Trinita Bahana Persada. All rights reserved.",
    },
  },
};
